import React, { CSSProperties } from 'react';
import './spinnerloader.css';
import MoonLoader from 'react-spinners/MoonLoader';
import css from '../../styles/modules/common/spinnerloader.module.css';

const SpinnerLoader = ({ isLoading, color }) => {
  return (
    <div className={css.wrapper}>
      <MoonLoader
        color={'#4162fa'}
        loading={isLoading || true}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default SpinnerLoader;
